// src/domains/shell.keys.ts —— 模板键归属（TD-823，agent-keys 用例按片 owner 推导核对）
export const KEYS = [
  'closeModal', 'doLogin', 'enBtn', 'isApp', 'isLogin', 'langLabel', 'loginUser', 'logout', 'me', 'modal', 'modalOpen', 'nav', 'onLoginUser',
  'openMyPwd', 'pageHint', 'pageTitle', 'pg', 'saving', 'setEn', 'setZh', 't', 'toast', 'toggleLang', 'zhBtn',
  'loginPwd', 'onLoginPwd', 'loginErr', 'busyLogin', 'isFcp', 'fcp', 'onFcp', 'fcpErr', 'fcpSubmit', 'busyFcp', 'isBooting',
  'idle', // 0210b 空闲自动退出提示框（2026-10-15）
] as const;
export const MODAL_KEYS = ['kind', 'title'] as const;
